export default __webpack_public_path__ + "static/media/illustration_nicoiq-exclusives.5f9ad526.png";